import api from '../utils/api';

export const getInboxList = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/messagelog/getAllInbox`,
        method: "POST",
        data: data,
        ...options,
    });
}

export const GetALLAppointmentStatus = (config = {}) => {
    const { options } = config;
    return api({
        url: '/api/appointment/getAllAppointmentStatus',
        method: 'GET',
        ...options,
    });
};

export const editAppointmentStatus = (config = {}) => {
    const { options } = config;
    return api({
        url: '/api/appointment/editAppointmentStatus',
        method: 'POST',
        ...options,
    });
};

export const addInboxComposeMessageLog = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/messagelog/addinboxcomposemessagelog`,
        method: "POST",
        data: data,
        ...options,
    });
}

export const getMessageLogHistory = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/patient/getMessageLogHistory/${data.phoneNumberId}/${data.maxMessageId}`,       
        method: "GET",
        ...options,
    });
}

export const getAppointmentListList = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/appointment/getAllAppointmentByLocation`,
        method: "POST",
        data: data,
        ...options,
    });
}